export const PRIMARY_COLOR = '#1c69d4';
export const PRIMARY_COLOR_HOVER = '#0653b6';
export const PRIMARY_COLOR_DISABLED = '#0653b64d';
export const PRIMARY_FONT_COLOR = '#262626';
